module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_16-bd5644c8dfbcad31120570b371e89f20.jpg";